import { FC, Fragment, useContext, useEffect, useRef, useState } from "react";
import {
  Button,
  Modal,
  Form,
  Input,
  Divider,
  Spin,
  InputRef,
  Select,
  InputNumber,
  DatePicker,
  Col,
  Row,
} from "antd";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { useClient } from "../../Context/ClientContext";
import { notificationContext } from "../../Common/PageRoute";
import { Voucher_Type } from "../../Services/VoucherServices";
import LedgerService, {
  SearchLedgerByGroupsTypes,
} from "../../Services/LedgerService";
import AddLedger from "../Master/Ledger/AddLedger";
import { findUserOnlyOnePremission } from "../Users/UserSecurityFind";
import { useUser } from "../../../Context/UserContext";

const AddSalesInvoiceDespatchDetails: FC<{
  open: boolean;
  onCancel: any;
  data: any;
  saveData: any;
  voucherType: Voucher_Type;
}> = (props) => {
  console.log("props", props);
  const inputRef = useRef<InputRef>(null);
  const [form] = Form.useForm();
  const { currentClient } = useClient();
  const { clientSpecificRole } = useUser();
  const { openNotification } = useContext(notificationContext);
  const [saveButtonLoading, setSaveButtonLoading] = useState<boolean>(false);
  // const [groupData, setGroupData] = useState<any[]>();
  const [trigger, setTrigger] = useState(false);
  const [addLedgerResponse, setAddLedgerResponse] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [transporterCoName, setTransporterCoName] = useState<any[]>([]);
  const [openModel, setOpenModel] = useState<{ type: string; param: any }>({
    type: "",
    param: {},
  });

  const saveGroup = () => {
    form.validateFields().then(async (value) => {
      //   setSaveButtonLoading(true);
      const saveData = {
        ...value,
        transporterCoName:
          props.voucherType === Voucher_Type.SalesVoucher
            ? {
                id: value?.transporterCoName?.value,
                name: value?.transporterCoName?.label,
              }
            : {
                name: value?.transporterCoName,
              },
      };
      props.data(saveData);
      console.log(saveData);
    });
  };

  useEffect(() => {
    const getApi = async () => {
      if (props.voucherType === Voucher_Type.SalesVoucher) {
        try {
          setLoading(true);
          await LedgerService.getLedgersByGroupName(
            currentClient?.id!,
            SearchLedgerByGroupsTypes.TransporterOnly
          ).then((res: any) => {
            setTransporterCoName(res);
            setLoading(false);
          });
        } catch (err: any) {
          // console.error("error", err);
          openNotification("error", err.message);
          setLoading(false);
        }
      }
    };
    getApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.voucherType, trigger]);

  useEffect(() => {
    if (props.saveData) {
      const data = {
        ...props.saveData,
        transporterCoName:
          props.voucherType === Voucher_Type.SalesVoucher
            ? {
                value: props.saveData?.transporterCoName?.id,
                label: props.saveData?.transporterCoName?.name,
              }
            : props.saveData?.transporterCoName?.name,
      };
      form.setFieldsValue(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.saveData]);

  //------- Set partner Data After Adding ledger ------
  useEffect(() => {
    if (addLedgerResponse) {
      // debugger;
      const exists = transporterCoName.some(
        (option) => option.id === addLedgerResponse.id
      );
      if (exists) {
        form.setFieldValue("partyLedger", {
          key: addLedgerResponse?.id,
          value: addLedgerResponse?.id,
          label: addLedgerResponse?.ledgerName,
        });
        // CustomerSelect(addLedgerResponse?.id);
        // setAddLedgerResponse(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transporterCoName]);

  return (
    <Fragment>
      <Modal
        open={props.open}
        title={`Add ${
          props.voucherType === Voucher_Type.SalesVoucher
            ? "Despatch"
            : "Receipt"
        } Details`}
        maskClosable={false}
        width={750}
        style={{ top: 44 }}
        onCancel={() => props.onCancel({})}
        footer={
          <div style={{ marginTop: "0px" }}>
            <Button
              onClick={() => {
                form.resetFields();
                props.onCancel({});
              }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={() => saveGroup()}
              style={{ width: "80px" }}
              loading={saveButtonLoading}
              className="modelSaveButtonMargin"
            >
              Save
            </Button>
          </div>
        }
      >
        <Spin
          indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
          spinning={loading}
        >
          <Form
            name="despatchDetail"
            form={form}
            autoComplete="off"
            colon={false}
            labelAlign="left"
            // initialValues={intialValue}
            labelCol={{ xs: 8, sm: 10 }}
            wrapperCol={{ xs: 15, sm: 14 }}
            labelWrap={true}
          >
            <Divider className="ca-model-css" />
            <Row
              style={{ justifyContent: "space-between" }}
              gutter={{ sm: 14 }}
            >
              <Col sm={12} xs={24}>
                <Form.Item
                  name="delNoteNo"
                  label={
                    props.voucherType === Voucher_Type.SalesVoucher
                      ? "Delivery Note No."
                      : "Receipt Note No."
                  }
                  className="mb-14"
                  // className="inputBoxMb8"
                  //   rules={[{ required: true, message: "Account Code is required" }]}
                >
                  <Input
                    autoFocus={true}
                    ref={inputRef}
                    placeholder="Delivery Note No."
                  />
                </Form.Item>
              </Col>

              <Col sm={12} xs={24}>
                <Form.Item
                  name="desDocNo"
                  label={
                    props.voucherType === Voucher_Type.SalesVoucher
                      ? "Despatch Doc. No"
                      : "Receipt Doc. No"
                  }
                  className="mb-12"
                >
                  <Input placeholder="Despatch Doc. No" />
                </Form.Item>
              </Col>

              <Col sm={12} xs={24}>
                <Form.Item
                  name="delNoteDate"
                  label="Date"
                  className="mb-14"
                  //   rules={[{ required: true, message: "Account Code is required" }]}
                >
                  <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} />
                </Form.Item>
              </Col>

              <Col sm={12} xs={24}>
                <Form.Item
                  name="vehicleNo"
                  label="Vehicle No."
                  className="mb-12"
                >
                  <Input placeholder="Vehicle No." />
                </Form.Item>
              </Col>

              <Col sm={12} xs={24}>
                <Form.Item
                  name="transporterCoName"
                  label="Transporter Co. Name"
                  className="mb-14"
                  //   rules={[{ required: true, message: "Account Type is required" }]}
                >
                  {props.voucherType === Voucher_Type.SalesVoucher ? (
                    <Select
                      showSearch
                      allowClear
                      labelInValue
                      optionFilterProp="children"
                      placeholder="Transporter Name"
                      filterOption={(input, option) =>
                        (option?.label?.toString() ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      options={transporterCoName?.map((value: any) => ({
                        value: value?.id,
                        label: value?.ledgerName.concat(
                          value?.aliasName
                            ? `${" (" + value?.aliasName + ")"}`
                            : ""
                        ),
                      }))}
                      // dropdownRender={(menu) => (
                      //   <>
                      //     {menu}
                      //     <Divider style={{ margin: "8px 0" }} />
                      //     <Input
                      //       placeholder="Please enter item"
                      //       // value={name}
                      //       // onChange={onNameChange}
                      //       onKeyDown={(e) => e.stopPropagation()}
                      //     />
                      //     <Button
                      //       type="text"
                      //       icon={<PlusOutlined />}
                      //       // onClick={addItem}
                      //     >
                      //       Add item
                      //     </Button>
                      //   </>
                      // )}
                      dropdownRender={(customerOptions) => (
                        <>
                          {customerOptions}

                          {findUserOnlyOnePremission(
                            "Master.Ledger.Customer.Add",
                            clientSpecificRole(),
                            currentClient?.id
                          ) && (
                            <>
                              <Divider style={{ margin: "5px 0px" }} />
                              <Button
                                style={{ width: "100%" }}
                                icon={<PlusOutlined />}
                                type="link"
                                onClick={() => {
                                  setOpenModel({
                                    type: "addLedger",
                                    param: {
                                      open: true,
                                      defaultGroup:
                                        // props.voucherType === Voucher_Type.SalesVoucher
                                        //   ? {
                                        //       id: "6603afaa99242bad67d446cd",
                                        //       ledgerName:
                                        //         "Trade Receivables - Sundry Debtors",
                                        //       parent: "65af9ce61a48db26effbb598",
                                        //     }
                                        //   :
                                        {
                                          id: "6603afe599242bad67d446d3",
                                          ledgerName:
                                            "Trade Payables - Sundry Creditors",
                                          parent: "65af9df71a48db26effbb5a3",
                                        },
                                      ledgerByGroupsType:
                                        // props.voucherType === Voucher_Type.SalesVoucher
                                        //   ? SearchLedgerByGroupsTypes.DebtorsOnly
                                        //   :
                                        SearchLedgerByGroupsTypes.CreditorsOnly,
                                      showName:
                                        // props.voucherType === Voucher_Type.SalesVoucher
                                        //   ? "Customer"
                                        //   :
                                        "Supplier",
                                    },
                                  });
                                }}
                              >
                                {props.voucherType === Voucher_Type.SalesVoucher
                                  ? "Customer"
                                  : "Supplier"}
                              </Button>
                            </>
                          )}
                        </>
                      )}
                    />
                  ) : (
                    <Input placeholder="Transporter Name" />
                  )}
                </Form.Item>
              </Col>
              <Col sm={12} xs={24}>
                <Form.Item
                  name="transporterOwnerName"
                  label="Transporter Owner Name"
                  className="mb-12"
                >
                  <Input placeholder="Transporter Owner Name" />
                </Form.Item>
              </Col>

              {props.voucherType === Voucher_Type.SalesVoucher && (
                <>
                  <Col sm={12} xs={24}>
                    <Form.Item
                      name="driverName"
                      label="Driver Name"
                      className="mb-12"
                    >
                      <Input placeholder="Driver Name" />
                    </Form.Item>
                  </Col>
                  <Col sm={12} xs={24}>
                    <Form.Item
                      name="driverContactNo"
                      label="Driver Contact No."
                      className="mb-12"
                      rules={[
                        {
                          message: "Enter 10 valid digit Phone No.",
                          pattern: /^[6-9]{1}[0-9]{9}$/,
                        },
                      ]}
                    >
                      <InputNumber
                        style={{ width: "100%" }}
                        placeholder="9876543210"
                        minLength={10}
                        maxLength={10}
                        controls={false}
                      />
                    </Form.Item>
                  </Col>
                </>
              )}

              <Col sm={12} xs={24}>
                <Form.Item
                  name="destination"
                  label="Destination"
                  className="mb-14"
                  //   rules={[{ required: true, message: "Nature is required" }]}
                >
                  <Input placeholder="Destination" />
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Divider className="divider-account" />
        </Spin>
      </Modal>
      {openModel.type === "addLedger" && (
        <AddLedger
          openDrawer={openModel?.param.open}
          id={null}
          setOpenDrawer={() => setOpenModel({ type: "", param: "" })}
          setTrigger={setTrigger}
          type={openModel?.param?.ledgerByGroupsType}
          setAddLedgerResponse={setAddLedgerResponse}
          // setRefresh={setRefresh}
          defaultGroup={openModel?.param?.defaultGroup}
          showName={openModel?.param?.showName}
        />
      )}
    </Fragment>
  );
};

export default AddSalesInvoiceDespatchDetails;
